import { styled } from "@linaria/react";
import { Link } from "react-router-dom";

const ProjectLink = styled(Link)`
  text-decoration: none;
`;

export const ProjectLinkStyle = {
  ProjectLink,
};
